export function filterObject<T>(
  o: { [key: string]: T },
  predicate: (key: string, v: T) => boolean,
): { [key: string]: T } {
  return Object.fromEntries(Object.entries(o).filter(([k, v]) => predicate(k, v)));
}
